import React from "react";
import { ArrowLeft, ArrowRight, AlertCircle, Sparkles } from "lucide-react";
import { FadeUpGroup } from "../components/FadeUpGroup";
import { getIndustry } from "../lib/industries";

export const IndustryDetailPage = ({ slug }) => {
    const ind = getIndustry(slug);
    if (!ind) {
        return (
            <section className="section">
                <div className="container">
                    <p className="muted">Unknown industry. <a href="/industries" className="link-arrow">Back to industries →</a></p>
                </div>
            </section>
        );
    }
    const Icon = ind.icon;

    return (
        <>
            <section className="section" data-testid={`industry-detail-${ind.slug}`}>
                <div className="container">
                    <a href="/industries" className="link-arrow" style={{ marginBottom: 18 }} data-testid="industry-back-link">
                        <ArrowLeft size={14} /> All industries
                    </a>
                    <FadeUpGroup>
                        <div className="fade-up" style={{ maxWidth: 760 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 18 }}>
                                <span className="icon-big"><Icon size={32} /></span>
                                <div>
                                    <div className="sub">Industry · {ind.name}</div>
                                </div>
                            </div>
                            <h1 className="h1" style={{ fontSize: "clamp(2.25rem, 4vw, 3.5rem)" }}>{ind.hero}</h1>
                            <p className="lead" style={{ marginTop: 22 }}>{ind.intro}</p>
                            <div className="industry-chips" style={{ marginTop: 26 }}>
                                {ind.products.map((p) => (
                                    <span key={p} className="chip" style={{ color: "var(--accent)", borderColor: "var(--border-strong)" }}>{p}</span>
                                ))}
                            </div>
                        </div>

                        <div className="stat-grid fade-up" style={{ marginTop: 56 }}>
                            {ind.metrics.map((m) => (
                                <div key={m.l} className="stat-card" data-testid={`industry-metric-${m.l.toLowerCase().replace(/\s+/g, "-")}`}>
                                    <div className="num">{m.v}</div>
                                    <div className="label">{m.l}</div>
                                </div>
                            ))}
                        </div>
                    </FadeUpGroup>
                </div>
            </section>

            <section className="section" style={{ background: "var(--surface)" }}>
                <div className="container">
                    <div className="section-head left">
                        <span className="eyebrow">The pain</span>
                        <h2 className="h2" style={{ marginTop: 18 }}>What breaks in a typical {ind.name.toLowerCase()} business</h2>
                    </div>
                    <FadeUpGroup>
                        <div className="challenge-grid">
                            {ind.challenges.map((c, i) => (
                                <div key={i} className="card fade-up">
                                    <span className="icon-square" style={{ background: "rgba(240,136,62,0.14)", color: "#f0883e" }}>
                                        <AlertCircle size={20} />
                                    </span>
                                    <p style={{ marginTop: 12, color: "var(--text)" }}>{c}</p>
                                </div>
                            ))}
                        </div>
                    </FadeUpGroup>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="section-head left">
                        <span className="eyebrow">The fix</span>
                        <h2 className="h2" style={{ marginTop: 18 }}>How Scitus.ai solves it for {ind.name.toLowerCase()}</h2>
                    </div>
                    <FadeUpGroup>
                        <div className="solution-grid">
                            {ind.solutions.map((s) => (
                                <div key={s.h} className="card fade-up" data-testid={`solution-${s.h.toLowerCase().replace(/\s+/g, "-")}`}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                        <span className="icon-square"><Sparkles size={18} /></span>
                                        <span className="chip" style={{ color: "var(--accent)" }}>{s.product}</span>
                                    </div>
                                    <h3 className="h3" style={{ marginTop: 14, fontSize: "1.1rem" }}>{s.h}</h3>
                                    <p className="muted" style={{ marginTop: 8 }}>{s.p}</p>
                                </div>
                            ))}
                        </div>
                    </FadeUpGroup>
                </div>
            </section>

            <section className="section" style={{ paddingTop: 0 }}>
                <div className="container">
                    <div className="cta-banner">
                        <div>
                            <h2 className="h2">See Scitus.ai for {ind.name.toLowerCase()}.</h2>
                            <p className="lead mt-4">A 30-minute demo with the products and dashboards your industry actually needs.</p>
                        </div>
                        <a href="/contact" className="btn btn-primary btn-lg" data-testid={`industry-cta-${ind.slug}`}>
                            Book a Demo <ArrowRight size={18} />
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default IndustryDetailPage;
